// Reads corpus statistics injected into window.Aedu.SiteStats by the server
// (see AcademiaEdu#as_json). SSR-safe: when the global is unavailable (server-
// side render or tests) it returns the canonical server defaults. The
// authoritative value is always the server-injected one — these defaults only
// guard the no-window edge case.

interface SiteStats {
  paper_count_in_millions?: number;
  scanned_paper_count_in_millions?: number;
}

// Best-effort fallbacks for the no-window edge case (SSR / tests) ONLY. The
// authoritative value is the server-injected one. paper_count is computed live
// server-side (Attachment.paper_count / 1_000_000), so this constant is a
// frozen snapshot of its current rounding, not a design value. If you change
// Attachment.paper_count or AcademiaEdu.scanned_paper_count_in_millions,
// update these to match (those sources carry a comment pointing back here).
const DEFAULT_PAPER_COUNT_IN_MILLIONS = 55;
const DEFAULT_SCANNED_PAPER_COUNT_IN_MILLIONS = 100;

function siteStats(): SiteStats {
  if (typeof window === 'undefined') return {};
  const aedu = window.Aedu as
    | (typeof window.Aedu & { SiteStats?: SiteStats })
    | undefined;
  return (aedu && aedu.SiteStats) || {};
}

export function paperCountInMillions(): number {
  return siteStats().paper_count_in_millions ?? DEFAULT_PAPER_COUNT_IN_MILLIONS;
}

export function scannedPaperCountInMillions(): number {
  return (
    siteStats().scanned_paper_count_in_millions ??
    DEFAULT_SCANNED_PAPER_COUNT_IN_MILLIONS
  );
}
